// @import components
import InfoSection from 'components/InfoSection';
// @import dependencies
import { useSelector } from 'react-redux';

const RightSide = () => {
  const { info } = useSelector(state => state.home);
  return (
    <div className='flex flex-col  space-y-3'>
      <InfoSection title='News and Updates'>
        <div
          className={`${info?.newsAndUpdates?.length ? 'h-[400px] overflow-auto' : 'h-[200px]'} `}
        >
          {info?.newsAndUpdates?.length ? (
            info?.newsAndUpdates?.map(x => (
              <div key={x.date} className='py-2'>
                <p className='text-[16px] font-medium text-primary'>
                  {x?.heading}
                </p>
                <p className='text-[14px] text-green-700'>{x?.date}</p>
                <p className='text-[12px] text-gray-400'>{x?.content}</p>
                <hr className='mt-2' />
              </div>
            ))
          ) : (
            <div className='flex size-full items-center justify-center text-center font-medium text-primary'>
              No News and Updates
            </div>
          )}
        </div>
      </InfoSection>
      {/* <InfoSection title='Account'>
        <div className='flex flex-col space-y-3'>
          <p>Money Transfer</p>
          <p>Pay Bills</p>
          <p>Bank Transfer</p>
        </div>
      </InfoSection>
      <InfoSection title='Personal Details'>
        <div className='flex flex-col space-y-3'>
          <p>Money Transfer</p>
          <p>Pay Bills</p>
          <p>Bank Transfer</p>
        </div>
      </InfoSection> */}
    </div>
  );
};

export default RightSide;
